module.exports = __webpack_public_path__ + "img/Alloxentric-white-logo.e1c8fc79.png";